export { useAnalytics, useAnalyticsWithAttributes } from './analyticsHooks';

export { BaseInvitePeopleAnalytics } from './BaseInvitePeopleAnalytics';
export {
	useCommonAttributesFrom,
	toCommonAttributes,
	type CommonAttributes,
} from './commonAttributes';

export type InviteeListId = 'CreateableSelect' | 'UserPicker' | 'TeamOrUserPicker';

export const CREATEABLE_SELECT_ID: InviteeListId = 'CreateableSelect';
export const USER_PICKER_ID: InviteeListId = 'UserPicker';
export const TEAM_OR_USER_PICKER_ID: InviteeListId = 'TeamOrUserPicker';

export type FailedFetchAttributes = {
	error?: Error;
	errorMessage: string;
	responseCode?: number;
};

export const qualifiesForViralSettings = (role: string) => role === 'admin';
